import React from "react";

import { PeopleCard, PeopleList } from "@caelor/ui";

import { useOpticsStore } from "../../../../../../stores/use-optics-store";
import { PeopleContainer, PeopleTitle, PeopleWrapper } from "./styles";
import { useWorkAnniversaryStore } from "../../../../../../stores/use-work-anniversary-store";
import { useStyleguideColors } from "../../../../../../hooks/use-styleguide-colors";
import { DEFAULT_ACCENT_COLOR } from "../../../../../../features/people/defaults";
import { WORK_ANNIVERSARY_TEMPLATES } from "./work-anniversary-templates";

const CardRender = ({ accent, borderRadius }) => (
  <div style={{ display: "flex", flexFlow: "row", gap: 8 }}>
    <div style={{ width: 166 }}>
      <PeopleCard
        name="Ava Turner"
        avatarUrl="/img/peopleList.svg"
        emoji="🎁"
        subtitle="Jun 23"
        label="Today"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
    <div style={{ width: 166 }}>
      <PeopleCard
        name="Liam Brooks"
        avatarUrl="/img/peopleCard.svg"
        subtitle="Jun 30"
        label="7 Days"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
  </div>
);

const ListRender = ({ accent, borderRadius }) => (
  <div style={{ display: "flex", flexFlow: "column", gap: 8 }}>
    <div style={{ width: 475 }}>
      <PeopleList
        name="Angelica Lorens"
        avatarUrl="/img/peopleList.svg"
        emoji="🎁"
        subtitle="Jun 23"
        label="Today"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
    <div style={{ width: 475 }}>
      <PeopleList
        name="Liam Brooks"
        avatarUrl="/img/peopleCard.svg"
        subtitle="Jun 30"
        label="7 Days"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
    <div style={{ width: 475 }}>
      <PeopleList
        name="Ava Turner"
        avatarUrl="/img/peopleList.svg"
        subtitle="Aug 23"
        label="7 Days"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
  </div>
);

const VIEWS = {
  card: { label: "Card", View: CardRender },
  list: { label: "List", View: ListRender },
};

const WorkAnniversaryTemplates = () => {
  const { setData, data } = useWorkAnniversaryStore((state) => ({
    setData: state.setData,
    data: state.data,
  }));
  const { setDrawers, styleguideSetup } = useOpticsStore((state) => ({
    setDrawers: state.setDrawers,
    styleguideSetup: state.styleguideSetup,
  }));

  const styleguideColors = useStyleguideColors({
    styleguideSetup,
  });

  const color =
    data?.accentColor || styleguideColors?.accent || DEFAULT_ACCENT_COLOR;

  const borderRadius = data?.borderRadius || styleguideSetup?.cornerRadius || 3;

  const buildData = (template, value) => {
    if (Object.keys(data || {}).length) {
      return {
        ...data,
        view: value.view,
      };
    }

    return {
      ...template,
      ...value,
    };
  };

  return (
    <PeopleContainer>
      {WORK_ANNIVERSARY_TEMPLATES.map((template) => {
        const { label, View } = VIEWS[template.view];
        return (
          <PeopleWrapper
            key={template.id}
            onClick={() => {
              setData({
                ...buildData(template, {
                  accentColor: color,
                  borderRadius,
                  view: template.view,
                }),
              });
              setDrawers({ templates: false, settings: true });
            }}
          >
            <PeopleTitle>{label}</PeopleTitle>
            <View accent={color} borderRadius={borderRadius} />
          </PeopleWrapper>
        );
      })}
    </PeopleContainer>
  );
};

export default WorkAnniversaryTemplates;
